import React, {
  useState,
} from 'react';
import './settings.css';
import SideBar from './SideBar';
import TimeoffPolicyPanel from './TimeoffPolicyPanel';
import HolidaysPanel from './HolidaysPanel';
import TimeoffBalancePanel from './TimeOffBalancePanel';

function TimeOff() {
  const [selectedItem, setSelectedItem] = useState(1);

  const handleSelect = async (index) => {
    setSelectedItem(index);
  };

  const listItemTexts = [
    'Time off policies',
    'Holidays',
    'Time off balances',
  ];
  return (
    <div className="flex" style={{ minHeight: 'calc(100vh - 320px)' }}>
      <SideBar handleSelect={handleSelect} listItemTexts={listItemTexts} />
      <div className="flex-grow-1 min-w-0">
        { selectedItem === 1 && <TimeoffPolicyPanel /> }
        { selectedItem === 2 && <HolidaysPanel /> }
        { selectedItem === 3 && <TimeoffBalancePanel /> }
      </div>
    </div>
  );
}

export default TimeOff;
